<template>
  <div class="card-wrapper">
    <div class="card-top">
      <div class="card-header">
        <div class="card-heading">
          <div class="card-icon">
            <i class="el-icon-picture"></i>
          </div>
          <div>
            <p class="card-title">Thống kê album ảnh</p>
            <p class="card-subtitle">Tình trạng đăng album ảnh ngày hiện tại</p>
            <div class="header-tags">
              <span class="header-tag">Tổng số lớp: {{ todayData.length }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="summary-row">
        <div class="summary-card" style="--summary-accent: #4f8dfd">
          <span class="summary-label">Tổng số lượng album</span>
          <strong class="summary-value">{{ totalAlbums }}</strong>
        </div>
        <div class="summary-card" style="--summary-accent: #36cfc9">
          <span class="summary-label">Đã duyệt</span>
          <strong class="summary-value">{{ totalApproved }}</strong>
        </div>
        <div class="summary-card" style="--summary-accent: #ff6b6b">
          <span class="summary-label">Chưa duyệt</span>
          <strong class="summary-value">{{ totalUnapproved }}</strong>
        </div>
      </div>
    </div>

    <el-row :gutter="20" class="chart-row">
      <el-col :xs="24" :sm="24" :md="8" :lg="8">
        <div class="chart-shell">
          <div class="chart-caption">
            <span class="chart-caption__dot" style="background: #4f8dfd; box-shadow: 0 0 0 4px rgba(79, 141, 253, 0.14);"></span>
            <span>Tỷ lệ trạng thái</span>
          </div>
          <div class="chartPie">
            <ChartPie
              v-if="loaded"
              :chartData="pieChartData"
              :options="pieChartOptions"
              :checkLable="true"
              :height="260"
            ></ChartPie>
            <div class="donut-center-text" v-if="loaded">
              <p class="center-value">{{ totalAlbums }}</p>
              <p class="center-label">Album</p>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="16" :lg="16">
        <div class="chart-shell">
          <div class="chart-caption">
            <span class="chart-caption__dot" style="background: #36cfc9; box-shadow: 0 0 0 4px rgba(54, 207, 201, 0.14);"></span>
            <span>Theo lớp học</span>
          </div>
          <div class="chartBar-scroll-container">
            <div class="chartBar-inner" :style="{ minWidth: chartMinWidth }">
              <ChartBar
                v-if="loaded"
                :chartData="barChartData"
                :options="barChartOptions"
                :height="260"
              ></ChartBar>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <div class="action-row" style="display: flex; justify-content: space-between; align-items: center; padding: 0 10px;">
      <div style="font-weight: 700; color: #22324d; font-size: 16px;">
        Danh sách chi tiết theo khoảng thời gian
      </div>
      <div>
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="-"
          start-placeholder="Từ ngày"
          end-placeholder="Đến ngày"
          format="dd/MM/yyyy"
          value-format="yyyy-MM-dd"
          size="small"
          @change="fetchTableData"
          :clearable="false"
          style="margin-right: 12px; width: 250px;"
        >
        </el-date-picker>
        <el-button type="primary" plain icon="el-icon-s-data" round size="small" @click="showTable = !showTable">
          {{ showTable ? 'Ẩn bảng' : 'Hiện bảng' }}
        </el-button>
      </div>
    </div>

    <el-collapse-transition>
      <div v-show="showTable" class="table-wrapper">
        <el-table 
          :data="tableData" 
          border 
          style="width: 100%" 
          stripe 
          header-cell-class-name="custom-header" 
          max-height="400"
          show-summary
          :summary-method="getSummaries"
        >
          <el-table-column type="index" label="STT" width="60" align="center"></el-table-column>
          <el-table-column prop="className" label="Tên" min-width="150"></el-table-column>
          <el-table-column prop="total" label="Tổng số album" align="center" min-width="120"></el-table-column>
          <el-table-column prop="approved" label="Đã duyệt" align="center" min-width="120">
            <template slot-scope="scope">
              <span class="text-success font-weight-bold">{{ scope.row.approved }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="unapproved" label="Chưa duyệt" align="center" min-width="120">
            <template slot-scope="scope">
              <span class="text-danger font-weight-bold">{{ scope.row.unapproved }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
import ChartPie from "@/views/chartStatistical/chart/ChartPie.vue";
import ChartBar from "@/views/chartStatistical/chart/ChartBar.vue";
import AlbumService from "@/services/AlbumService";
import moment from "moment";

export default {
  name: "AlbumStatisticsCard",
  components: {
    ChartPie,
    ChartBar,
  },
  data() {
    return {
      loaded: false,
      showTable: false,
      dateRange: [
        moment().subtract(6, "days").format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD"),
      ],
      todayData: [],
      tableData: [],
      pieChartData: {},
      pieChartOptions: {},
      barChartData: {},
      barChartOptions: {},
      colors: {
        approved: "#36cfc9",
        unapproved: "#ff6b6b",
        total: "#4f8dfd"
      }
    };
  },
  computed: {
    totalAlbums() {
      return this.todayData.reduce((acc, curr) => acc + curr.total, 0);
    },
    totalApproved() {
      return this.todayData.reduce((acc, curr) => acc + curr.approved, 0);
    },
    totalUnapproved() {
      return this.todayData.reduce((acc, curr) => acc + curr.unapproved, 0);
    },
    chartMinWidth() {
      const minRequired = this.todayData.length * 70; // 70px per class
      return minRequired > 0 ? `max(100%, ${minRequired}px)` : '100%';
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const response = await AlbumService.getAlbumStatisticsToday();
        this.todayData = response.data.data || [];
      } catch (error) {
        this.$message.error("Lỗi khi tải dữ liệu thống kê album hôm nay");
        this.todayData = [];
      }

      await this.fetchTableData();

      this.initPieChart();
      this.initBarChart();
      
      this.loaded = true;
    },
    async fetchTableData() {
      if (!this.dateRange || this.dateRange.length < 2) return;
      const startDate = this.dateRange[0];
      const endDate = this.dateRange[1];
      try {
        const response = await AlbumService.getAlbumStatisticsRange(startDate, endDate);
        this.tableData = response.data.data || [];
      } catch (error) {
        this.$message.error("Lỗi khi tải dữ liệu thống kê album theo thời gian");
        this.tableData = [];
      }
    },
    initPieChart() {
      this.pieChartData = {
        labels: ["Đã duyệt", "Chưa duyệt"],
        datasets: [
          {
            backgroundColor: [this.colors.approved, this.colors.unapproved],
            data: [this.totalApproved, this.totalUnapproved],
            borderWidth: 6,
            borderColor: "#ffffff",
            hoverBorderWidth: 6,
            hoverBorderColor: "#ffffff",
          },
        ],
      };

      this.pieChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 65,
        layout: {
          padding: { top: 12, right: 12, left: 12, bottom: 12 },
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            boxWidth: 12,
            padding: 20,
          }
        },
        tooltips: {
          backgroundColor: "rgba(19, 31, 53, 0.92)",
          titleFontSize: 12,
          bodyFontSize: 12,
          xPadding: 12,
          yPadding: 12,
        },
        plugins: {
          datalabels: {
            color: "#ffffff",
            anchor: "center",
            align: "center",
            font: { size: 12, weight: "700" },
            formatter: (value, ctx) => {
              const sum = ctx.dataset.data.reduce((acc, item) => acc + Number(item || 0), 0);
              if (!sum || !value) return "";
              const percent = (value * 100) / sum;
              return percent >= 5 ? `${percent.toFixed(1)}%` : "";
            },
          },
        },
      };
    },
    initBarChart() {
      const labels = this.todayData.map(item => item.className);
      const approvedData = this.todayData.map(item => item.approved);
      const unapprovedData = this.todayData.map(item => item.unapproved);

      this.barChartData = {
        labels: labels,
        datasets: [
          {
            label: "Đã duyệt",
            backgroundColor: this.colors.approved,
            data: approvedData,
            barPercentage: 0.6,
            categoryPercentage: 0.8,
            borderWidth: 0,
          },
          {
            label: "Chưa duyệt",
            backgroundColor: this.colors.unapproved,
            data: unapprovedData,
            barPercentage: 0.6,
            categoryPercentage: 0.8,
            borderWidth: 0,
          }
        ]
      };

      this.barChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: { top: 20, right: 10, left: 10, bottom: 10 }
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            usePointStyle: true,
            boxWidth: 8,
            padding: 20,
          }
        },
        scales: {
          xAxes: [{
            stacked: false,
            gridLines: { display: false, drawBorder: false },
            ticks: { fontColor: "#6b7a90", fontSize: 11, maxRotation: 45, minRotation: 0 }
          }],
          yAxes: [{
            stacked: false,
            display: true,
            gridLines: { color: "rgba(142, 169, 204, 0.18)", drawBorder: false, zeroLineColor: "rgba(142, 169, 204, 0.24)" },
            ticks: { beginAtZero: true, precision: 0, fontColor: "#7d8ca1", padding: 10 }
          }]
        },
        tooltips: {
          mode: "index",
          intersect: false,
          backgroundColor: "rgba(19, 31, 53, 0.92)",
          titleFontSize: 12,
          bodyFontSize: 12,
          xPadding: 12,
          yPadding: 12,
        },
        plugins: {
          datalabels: {
            display: false, // Ẩn label trên bar chart để tránh rối
          },
          zoom: {
            zoom: {
              enabled: false
            },
            pan: {
              enabled: false
            }
          }
        }
      };
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '';
          return;
        }
        if (index === 1) {
          sums[index] = 'Tổng cộng';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = '';
        }
      });
      return sums;
    }
  }
};
</script>
<style lang="scss" scoped>
.card-top {
  display: flex;
  flex-direction: column;
}

.card-wrapper {
  background: linear-gradient(180deg, #ffffff 0%, #f9fbff 100%);
  border-radius: 24px;
  box-shadow: 0 18px 40px rgba(31, 45, 61, 0.08);
  padding: 20px;
  margin: 20px 0;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(122, 147, 184, 0.12);
}

.card-wrapper:hover {
  box-shadow: 0 22px 48px rgba(31, 45, 61, 0.12);
  transform: translateY(-4px);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 18px;
}

.card-heading {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.card-icon {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #ffffff;
  background: linear-gradient(135deg, #13c2c2, #5cdbd3);
  box-shadow: 0 14px 24px rgba(92, 219, 211, 0.24);
}

.card-title {
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  color: #22324d;
}

.card-subtitle {
  margin: 6px 0 0;
  font-size: 13px;
  color: #7f8da3;
}

.header-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.header-tag {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  color: #31527f;
  background: rgba(79, 141, 253, 0.12);
}

.summary-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 18px;
}

.summary-card {
  position: relative;
  padding: 16px 18px;
  border-radius: 18px;
  background: #ffffff;
  border: 1px solid rgba(118, 153, 214, 0.14);
  box-shadow: 0 10px 24px rgba(31, 45, 61, 0.06);
  overflow: hidden;
}

.summary-card::before {
  content: "";
  position: absolute;
  inset: 0 auto 0 0;
  width: 4px;
  background: var(--summary-accent);
}

.summary-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #7d8ca1;
  margin-bottom: 8px;
}

.summary-value {
  display: block;
  font-size: 24px;
  line-height: 1;
  color: #21314c;
}

.chart-row {
  margin-bottom: 16px;
}

.chart-shell {
  position: relative;
  padding: 18px;
  border-radius: 24px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  border: 1px solid rgba(118, 153, 214, 0.14);
  height: 380px;
  display: flex;
  flex-direction: column;
}

.chart-caption {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  margin-bottom: 14px;
  border-radius: 999px;
  background: rgba(79, 141, 253, 0.08);
  color: #4f6483;
  font-size: 13px;
  font-weight: 600;
  align-self: flex-start;
}

.chart-caption__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.chartPie {
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chartPie > div {
  width: 100%;
}

.donut-center-text {
  position: absolute;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
  text-align: center;
  pointer-events: none;
}

.center-value {
  margin: 0;
  font-size: 26px;
  line-height: 1;
  font-weight: 800;
  color: #26344c;
}

.center-label {
  margin: 4px 0 0;
  font-size: 10px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: #8b99ad;
}

.chartBar-scroll-container {
  flex: 1;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 8px; /* For scrollbar space */
}

.chartBar-scroll-container::-webkit-scrollbar {
  height: 6px;
}

.chartBar-scroll-container::-webkit-scrollbar-track {
  background: rgba(142, 169, 204, 0.1);
  border-radius: 4px;
}

.chartBar-scroll-container::-webkit-scrollbar-thumb {
  background: rgba(142, 169, 204, 0.4);
  border-radius: 4px;
}

.chartBar-scroll-container::-webkit-scrollbar-thumb:hover {
  background: rgba(142, 169, 204, 0.6);
}

.chartBar-inner {
  height: 100%;
  position: relative;
}

.action-row {
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
}

.table-wrapper {
  margin-top: 10px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(31, 45, 61, 0.08);
  border: 1px solid rgba(122, 147, 184, 0.12);
}

.text-success {
  color: #36cfc9;
}

.text-danger {
  color: #ff6b6b;
}

.font-weight-bold {
  font-weight: bold;
}

::v-deep .custom-header {
  background-color: #f4f7ff !important;
  color: #3b4a74;
  font-weight: 700;
}

@media (max-width: 991px) {
  .chart-shell {
    margin-bottom: 16px;
  }
}

@media (max-width: 768px) {
  .summary-row {
    grid-template-columns: 1fr;
  }
}
</style>
